import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useMemo, useState } from "react";
import { Link, Spinner, Text } from "pcln-design-system";
import { useOtpContext } from "../../context/OtpContext.js";
import otpService from "../../utils/otpService.js";
import styled_components from "styled-components";
import { ChatbotDataContext } from "../../context/ChatbotDataContext.js";
const StyledLink = /*#__PURE__*/ styled_components(Link).withConfig({
    displayName: "ResentButton__StyledLink"
})([
    "text-decoration:underline;",
    ""
], ({ disabled })=>disabled && `
  text-decoration: none;
  `);
const ResendButton = ({ validOtpCode })=>{
    const errorMessage = 'I’m having some trouble accessing your trip information. ';
    const { setOtpRequestErrorMsg, otpResent, setOtpResent, setVerificationApiFunction, resendInProgress, setResendInProgress, otpFormData, otpDeliveryType } = useOtpContext();
    const [totalResendCount, setTotalResendCount] = useState(1);
    const otpServiceInstance = useMemo(()=>otpService({
            deliveryType: otpDeliveryType
        }), [
        otpService
    ]);
    const { phoneNumber, email, countryCode } = otpFormData || {};
    const [disableResendButton, setDisableResendButton] = useState(true);
    const { submitChatMessagesPayload, requestFrom } = useContext(ChatbotDataContext);
    const { cguid, resolvedClientIP } = submitChatMessagesPayload || {};
    const disableResendButtonFn = ()=>{
        setTimeout(()=>{
            setDisableResendButton(false);
        }, 120000);
    };
    useEffect(()=>{
        disableResendButtonFn();
    }, []);
    async function resendSmsCode(e) {
        setTotalResendCount(totalResendCount + 1);
        setResendInProgress(true);
        setOtpRequestErrorMsg('');
        try {
            const otpChallenge = await otpServiceInstance.createChallenge({
                phoneNumber,
                email,
                countryCode,
                scope: 'trips',
                requestHeaders: {
                    'x-pcln-client-ip': resolvedClientIP,
                    cguid
                },
                requestFrom
            });
            if (otpChallenge) {
                setVerificationApiFunction(()=>otpServiceInstance.verify);
                setOtpResent(true);
            } else setOtpRequestErrorMsg(errorMessage);
        } catch (e) {
            setOtpRequestErrorMsg(errorMessage);
        } finally{
            setDisableResendButton(true);
            setResendInProgress(false);
            if (totalResendCount <= 4) disableResendButtonFn();
        }
    }
    return /*#__PURE__*/ jsx(Fragment, {
        children: resendInProgress ? /*#__PURE__*/ jsx(Spinner, {}) : /*#__PURE__*/ jsx(Fragment, {
            children: !validOtpCode && /*#__PURE__*/ jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ jsxs(Text, {
                        mt: 2,
                        fontSize: 0,
                        children: [
                            "Didn't get the message?",
                            ' ',
                            /*#__PURE__*/ jsx(StyledLink, {
                                disabled: disableResendButton,
                                onClick: resendSmsCode,
                                children: "Resend"
                            })
                        ]
                    }),
                    otpResent ? /*#__PURE__*/ jsx(Text, {
                        fontWeight: 'bold',
                        children: "Message re-sent."
                    }) : null
                ]
            })
        })
    });
};
const ResentButton = ResendButton;
export { ResentButton as default };
